import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import { ProvideAuth } from "./components/common/use-auth.js";
import { HelmetProvider } from 'react-helmet-async';

import './i18n';

ReactDOM.render(
  <React.StrictMode>
    <HelmetProvider>
      <ProvideAuth>
        <BrowserRouter >
          <App />
        </BrowserRouter>
      </ProvideAuth>
    </HelmetProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
